<template>
    <v-card color="rgba(170,170,170,0.4)" class="" height="380" width="100%" style="overflow-y: auto">
        <v-card-title>
            {{passagens.dados.nome}}
        </v-card-title>
        <v-card-subtitle>
            {{passagens.dados.email}}<br />
            {{passagens.dados.grauAtual}}º grau - {{passagens.dados.claAtual}}
        </v-card-subtitle>
        <v-divider></v-divider>
        <v-card-text>
            <v-data-table fixed-header hide-default-footer :items="passagens.passagens" :headers="fields" :items-per-page="10">
                <template v-slot:item.data="{ item }">
					{{mostrarData(item.data)}}
				</template>
                <template v-slot:item.actions="{ item }">
                    <v-btn :disabled="item.grau == 1" text color="primary" @click.stop="editar(item)">
                        <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                    <v-btn :disabled="item.grau == 1" text color="primary" @click.stop="excluir(item)">
                        <v-icon>mdi-delete</v-icon>
                    </v-btn>
                </template>
            </v-data-table>
        </v-card-text>
    </v-card>
</template>

<script>
    import metodos from '@/mixins/metodos'
    import Br from '@/config/barramento'

	export default{
        name: "PassagensGrau",
        mixins:[metodos],
        props:['passagens'],
        components:{
            //Modal
            //EditarPassagem,
            },
		data(){
			return {
                
                data: '',
                dataFormatada: '',
                editarPassagem: false,
                itemPassagem: null,
				showModal: false,
                registro: {},
                totalPaginas: null,
                itensPorPagina: 5,
                paginaAtual: 1,
				fields: [
                    {text: 'Grau', value: 'grau', align: 'center', divider: true},
					{text: 'Data', value: 'data', align: 'center', divider: true},
					{text: 'Ações', value: 'actions', align: 'center', divider: true},
                ],
			}
		},

		methods:{

			chamaModal(registro){
                this.registro = registro
                this.showModal = true
                
            },
            close(){
                this.showModal = false
            },
            editar(passagem){
                
                // this.editarPassagem = true
               
                // this.itemPassagem = passagem
                Br.setEditarPassagem(passagem);
                
                //this.$router.push({name: 'passagemGrau', params: passagem})
            },
            excluir(passagem){
                Br.setExcluirPassagem(passagem);
            },
		},

        created(){
            
        }
	}
</script>

<style scoped>


</style>